import { useState } from 'react';
import { jobAPI } from '../../../services/api';

// Extracted verbatim from JobManagement.js (Task 4).
//
// Neither function here touches the shared `isLoading` flag in the original
// code, so this hook does not take `setIsLoading` — matching the interface
// in task-4-brief.md exactly.
//
// loadUserPreferences is called from a mount-only `useEffect(..., [])` in
// the orchestrator (not gated on activeTab) — that effect stays in the
// orchestrator and simply calls this hook's `loadUserPreferences`. See
// task-4-brief.md fact #2 and the "preferences load on mount regardless of
// which tab is active" characterization test.
export const useMechanicPreferences = () => {
  const [userPreferences, setUserPreferences] = useState({
    default_labor_rate: 100,
    default_tax_rate: 0.08,
    currency: 'USD',
    business_name: '',
    business_address: '',
    business_phone: '',
    invoice_notes: '',
    registration_number: '',
    warranty_terms: ''
  });
  const [preferencesLoaded, setPreferencesLoaded] = useState(false);
  const [savingPreferences, setSavingPreferences] = useState(false);

  const loadUserPreferences = async () => {
    try {
      const prefs = await jobAPI.getUserJobPreferences();
      setUserPreferences({
        default_labor_rate: prefs.default_labor_rate || 100,
        // ?? not ||: a shop that charges no tax saves 0, and 0 is a rate.
        default_tax_rate: prefs.default_tax_rate ?? 0.08,
        currency: prefs.currency || 'USD',
        business_name: prefs.business_name || '',
        business_address: prefs.business_address || '',
        business_phone: prefs.business_phone || '',
        invoice_notes: prefs.invoice_notes || '',
        registration_number: prefs.registration_number || '',
        warranty_terms: prefs.warranty_terms || ''
      });
      setPreferencesLoaded(true);
    } catch (error) {
      console.error('Error loading user preferences:', error);
      setPreferencesLoaded(true); // Still mark as loaded so we use defaults
    }
  };

  const saveUserPreferences = async () => {
    try {
      setSavingPreferences(true);
      await jobAPI.updateUserJobPreferences(userPreferences);
      alert('Settings saved successfully!');
    } catch (error) {
      console.error('Error saving preferences:', error);
      alert('Error saving settings: ' + (error.message || 'Unknown error'));
    } finally {
      setSavingPreferences(false);
    }
  };

  return {
    userPreferences,
    setUserPreferences,
    preferencesLoaded,
    savingPreferences,
    loadUserPreferences,
    saveUserPreferences
  };
};
